<script setup>

import { ref, inject, watch } from 'vue';
import { 
	apiModifierInfosRoutine,
	apiSupprimerRoutines } from '@/services/ServiceModele.js';
import FormuleAffichee from '@/components/generiques/FormuleAffichee.vue';
import Tag from 'primevue/tag';

const { routine } = defineProps({
  routine: Object
});

const emit = defineEmits(['editionArguments']);

const afficherBarreFlottante = inject('afficherBarreFlottante');
const appelerApiModifModele = inject('appelerApiModifModele');
const ouvrirFenetreFormule = inject('ouvrirFenetreFormule');

const infosRoutine = ref(getInfosRoutine(routine));
const boutonMenu = ref(null);

watch(() => getInfosRoutine(routine), (rout) => {
	infosRoutine.value = rout;
});

const itemsMenu = [
	{
		libelle: 'Supprimer',
		icones: ['fa fa-trash'],
		style: 'color: var(--couleur-supprimer); ',
		commande: () => {
			supprimer();
		}
	}
];

function getInfosRoutine(routine) {
	return {
		nom: routine?.nom,
		libelle: routine?.libelle
	};
}

function basculerAffichageMenu() {
    afficherBarreFlottante({
        items: itemsMenu, 
        selectionItems: [],
        composantParent: boutonMenu.value
    });
}

function afficherModaleEditionArguments() {
	emit('editionArguments', true);
}

function reinitialiserValeurs() {
	infosRoutine.value = getInfosRoutine(routine);
}

function modifierInfosRoutine() {
	appelerApiModifModele(apiModifierInfosRoutine, routine.id, infosRoutine.value);
}

function supprimer() {
	appelerApiModifModele(apiSupprimerRoutines, [routine]);
}

</script>

<template>
	<div class="detail-routine">
		<label class="intitule">Nom :</label>
		<div class="zone-nom">
			<input type="text" class="saisie-nom" spellcheck="false" 
				v-model="infosRoutine.nom" 
				@keyup.enter="modifierInfosRoutine()"
				@blur="reinitialiserValeurs" />
			<button class="bouton fa-solid fa-caret-down" 
				ref="boutonMenu"
				@click.stop="basculerAffichageMenu" />
		</div>
		<label class="intitule">Libellé :</label>
		<input type="text" spellcheck="false" 
			v-model="infosRoutine.libelle" 
			@keyup.enter="modifierInfosRoutine()"
			@blur="reinitialiserValeurs" />
		<label class="intitule">Arguments :</label>
		<div class="liste-badges" tabindex="0" @click="afficherModaleEditionArguments()">
			<label v-if="routine.arguments.length === 0" class="aucun"><i>Aucun</i></label>
			<Tag v-for="argument in routine.arguments" class="badge nom-argument">
				{{ argument.nom }}
			</Tag>
		</div>
		<label class="intitule">Formule :</label>
		<template v-if="routine.formule">
			<div
				class="zone-apercu-formule"
				:class="{'formule-en-erreur': routine.formuleEnErreur}"
				@click="ouvrirFenetreFormule(routine)">
				<FormuleAffichee :formule="routine?.formule" class="apercu-formule" />
			</div>
		</template>
		<div v-else>
			<label class="texte-formule-non-definie">Non définie</label>
		</div>
	</div>
</template>

<style scoped>

.detail-routine {
	display: grid;
	grid-template-columns: auto minmax(0, 1fr);
	gap: 2px;
	margin-top: 10px;
	margin-bottom: 20px;
	padding-left: 5px;
	align-items: start;
}

.zone-nom {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
}

.saisie-nom {
	margin-right: 2px;
	flex-grow: 1;
	min-width: 20px;
}

.liste-badges {
	border: solid 1px var(--couleur-bordure);
	border-radius: 2px;
	padding: 2px;
	user-select: none;
	background-color: white;
}

.liste-badges:hover {
	border-color: var(--couleur-survol);
	cursor: pointer;
}

.aucun {
	cursor: pointer;
}

.badge {
	border: solid 1px var(--couleur-bordure);
	border-radius: 5px;
	user-select: none;
	padding: 5px 7px;
	font-weight:700 !important;
	font-size: 8px !important;
}

.nom-argument {
	background-color: var(--couleur-colonne) !important;
	margin: 0px 1px;
	color: black;
}

.texte-formule-non-definie {
	margin-right: 5px;
	color: var(--couleur-erreur);
}

</style>